import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=b91137fe&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=b91137fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91137fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b91137fe')) {
      api.createRecord('b91137fe', component.options)
    } else {
      api.reload('b91137fe', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=b91137fe&scoped=true&", function () {
      api.rerender('b91137fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I50zaeURC6Je/JS/comp/GuestBox.vue"
export default component.exports